import { render, staticRenderFns } from "./ShowDialog.vue?vue&type=template&id=36fcfef2"
import script from "./ShowDialog.vue?vue&type=script&lang=js"
export * from "./ShowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports